import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'

import './assets/css/global.css'
// 导入iconfront
import './assets/font/iconfont.css'
import './assets/font_1/iconfont.css'

// 导入axios
import axios from 'axios'
// 打印

// 挂载axios 到Vue的原型prototype的$http
Vue.prototype.$http = axios
    // 设置请求的根路径
    // axios.defaults.baseURL = "http://localhost:1009/api"
axios.defaults.baseURL = "http://pj.lnbcgs.com/api"
axios.interceptors.request.use(config => {
    // console.log(config);
    // 请求头挂载信息
    config.headers.Authorization = window.sessionStorage.getItem("flag");
    // 在最后必须return config
    return config;
})
Vue.prototype.resetSetItem = function(key, newVal) {
        if (key === 'user') {
            // 创建一个StorageEvent事件
            var newStorageEvent = document.createEvent('StorageEvent');
            const storage = {
                setItem: function(k, val) {
                    sessionStorage.setItem(k, val);
                    // 初始化创建的事件
                    newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
                    // 派发对象
                    window.dispatchEvent(newStorageEvent)
                }
            }
            return storage.setItem(key, newVal);
        }
        if (key === 'activePath') {
            // 创建一个StorageEvent事件
            var newStorageEvent = document.createEvent('StorageEvent');
            const storage = {
                setItem: function(k, val) {
                    sessionStorage.setItem(k, val);
                    // 初始化创建的事件
                    newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
                    // 派发对象
                    window.dispatchEvent(newStorageEvent)
                }
            }
            return storage.setItem(key, newVal);
        }
    }
    // Vue.prototype.resetSetItem = function(key, newVal) {
    //     if (key === 'activePath') {
    //         // 创建一个StorageEvent事件
    //         var newStorageEvent = document.createEvent('StorageEvent');
    //         const storage = {
    //             setItem: function(k, val) {
    //                 sessionStorage.setItem(k, val);
    //                 // 初始化创建的事件
    //                 newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
    //                 // 派发对象
    //                 window.dispatchEvent(newStorageEvent)
    //             }
    //         }
    //         return storage.setItem(key, newVal);
    //     }
    // }

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
